import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
};


// Fetch Top Board
export const getTopBoard = createAsyncThunk(
    'advertiser/top-board',
    async (_, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.get(`/admin/advertiser-top-board`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

  //Create Advertiser
  export const createAdvertiser = createAsyncThunk(
    "/admin/create-advertiser",
    async (formData, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.post(`/admin/create-advertiser`, formData, config);
        return response.data;
      } catch (error) {
        console.error("Error Details:", error.response?.data || error.message);
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

  // Get All Advertisers
  export const getAllAdvertiser = createAsyncThunk(
    "/admin/all-advertisers",
    async (
      { page, rowsPerPage, name, state },
      { getState, rejectWithValue }
    ) => {
      try {
        const config = tokenConfig(getState);
        let params = `page=${page + 1}&limit=${rowsPerPage}`;
        if (name) {
          params += `&name=${encodeURIComponent(name)}`;
        }
        if (state) {
          params += `&state=${encodeURIComponent(state)}`;
        }
        //console.log(params);
        const response = await axios.get(`/admin/all-advertisers?${params}`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

  // Get Advertiser By Id
  export const getAdvertiserById = createAsyncThunk(
    '/admin/advertiser-by-id',
    async (id, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.get(`/admin/profile-advertiser/${id}`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

  // Update Advertiser
  export const updateAdvertiser = createAsyncThunk(
    "/admin/update-advertiser",
    async (formData, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.put(`/admin/update-advertiser`, formData, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

  // Status Advertiser
  export const statusAdvertiser = createAsyncThunk(
    "/admin/status-advertiser",
    async ({id, state}, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.post(`/admin/approval-advertiser/${id}/${state}`, {}, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );



  const advertiserSlice = createSlice({
    name: "advertiser",
    initialState: {
      loading: false,
      topBoard: {},
      advertisers: [],
      advertiser: [],
      meta: null,
      success: null,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        //get-topboard
        .addCase(getTopBoard.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getTopBoard.fulfilled, (state, action) => {
          state.loading = false;
          state.topBoard = action.payload.data;
        })
        .addCase(getTopBoard.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload?.message || "Failed to fetch topboard";
        })
        //create-advertiser
        .addCase(createAdvertiser.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(createAdvertiser.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.success;
        })
        .addCase(createAdvertiser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || "Failed to create advertiser";
        })
        //get-all-advertisers
        .addCase(getAllAdvertiser.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getAllAdvertiser.fulfilled, (state, action) => {
            state.loading = false;
            state.advertisers = action.payload.data;
            state.meta = action.payload.meta; // Store pagination meta
        })
        .addCase(getAllAdvertiser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || "Failed to fetch all advertisers";
        })
        //get-advertiser by id
        .addCase(getAdvertiserById.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getAdvertiserById.fulfilled, (state, action) => {
            state.loading = false;
            state.advertiser = action.payload.data;
        })
       .addCase(getAdvertiserById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || "Failed to fetch advertiser";
        })
        //update-advertiser
        .addCase(updateAdvertiser.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(updateAdvertiser.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.success;
        })
        .addCase(updateAdvertiser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || "Failed to update advertiser";
        })
        //status-advertiser
        .addCase(statusAdvertiser.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(statusAdvertiser.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.success;
        })
        .addCase(statusAdvertiser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || "Failed to update advertiser status";
        })

    },
  });
  
  export default advertiserSlice.reducer;